import { atom } from "recoil"

export const groupMemberListRequestIdState = atom<number>({
  key: "atoms/organization/group/groupMemberRequestListIdState",
  default: 0,
})
